import * as _ from 'lodash';

// select distinct source from items;
// public enum AssetFilterType
// {
// 	NestedChannel,
// 	ClipGroup,
// 	LiveProgramAssets,
// 	VODFileAssets,
// 	Image,
// 	Transitions,
// 	Collection, // useful for filtering out all collection types below
// 	Series,
// 	Season,
// 	Extra,
// 	Trailer,
// 	None
// }
import clipGroupIcon from '@/assets/icons/vn-icon-clip-group.svg';
import externalVideoIcon from '@/assets/icons/vn-icon-external-clip.svg';
import imageIcon from '@/assets/icons/vn-icon-image.svg';
import liveEventIcon from '@/assets/icons/vn-icon-live-event.svg';
import liveProgramAssetIcon from '@/assets/icons/vn-icon-live-program-asset.svg';
import nestedChannelIcon from '@/assets/icons/vn-icon-nested-collection.svg';
import transitionIcon from '@/assets/icons/vn-icon-transition.svg';
import videoClipIcon from '@/assets/icons/vn-icon-vod.svg';
// AssetFilterType LiveProgramAssets encompasses LiveEncoder and LiveStreamManager source types
// AssetFilterType VODFileAssets encompasses all source types except ClipGroup, NestedChannel, and LiveEncoder and LiveStreamManager
export enum AssetFilterType {
  NestedChannel = 'NestedChannel', // includes source types: "NestedChannel"
  ClipGroup = 'ClipGroup', // includes source types: "ClipGroup"
  LiveProgramAssets = 'LiveProgramAssets', // includes source types: "LiveEncoder" and "LiveStreamManager"
  VODFileAssets = 'VODFileAssets', // includes source types: "SubClip" "FeedIngest" "AdVariant" and "Ingest"
  Image = 'Image', // allows user to filter by schemaType = 'Image'
  Transitions = 'Transitions', // Allows user to filter by schemaType = 'Transitions'
  Collection = 'Collection',
  MediaLibrary = 'MediaLibrary', // A convenience to filter Series/Season/Extra/Trailer
  Series = 'Series',
  Season = 'Season',
  Extra = 'Extra',
  Trailer = 'Trailer',
  LiveEvent = 'LiveEvent',
  ExternalClip = 'ExternalClip',
  Broadcast = 'Broadcast',
}

export interface AssetFilterTypeOptions {
  id: AssetFilterType;
  name: string;
  label?: string;
  icon?: React.ReactNode;
  iconAlign?: 'left' | 'right';
}

export const AllAssetFilterTypeOptions: AssetFilterTypeOptions[] = [
  { id: AssetFilterType.NestedChannel, name: 'Nested/Collections' },
  { id: AssetFilterType.ClipGroup, name: 'Clip Groups' },
  { id: AssetFilterType.LiveProgramAssets, name: 'Live Program Assets' },
  { id: AssetFilterType.VODFileAssets, name: 'Videos' },
  { id: AssetFilterType.Transitions, name: 'Transitions' },
  { id: AssetFilterType.Image, name: 'Images' },
  { id: AssetFilterType.Series, name: 'Series' },
  { id: AssetFilterType.Season, name: 'Seasons' },
  { id: AssetFilterType.Extra, name: 'Extras' },
  { id: AssetFilterType.Trailer, name: 'Trailers' },
  { id: AssetFilterType.LiveEvent, name: 'Live Events' },
  { id: AssetFilterType.ExternalClip, name: 'External Clips' },
  { id: AssetFilterType.Broadcast, name: 'Broadcast' },
];

export const AssetFilterTypeOptions: AssetFilterTypeOptions[] = [
  { id: AssetFilterType.NestedChannel, name: 'Nested/Collections', label: 'Nested/Collections' },
  { id: AssetFilterType.ClipGroup, name: 'Clip Groups', label: 'Clip Groups' },
  { id: AssetFilterType.LiveProgramAssets, name: 'Live Program Assets' },
  { id: AssetFilterType.VODFileAssets, name: 'Videos' },
  { id: AssetFilterType.Series, name: 'Series', label: 'Series' },
  { id: AssetFilterType.Season, name: 'Seasons', label: 'Seasons' },
  { id: AssetFilterType.Extra, name: 'Extras', label: 'Extras' },
  { id: AssetFilterType.Trailer, name: 'Trailers', label: 'Trailers' },
  { id: AssetFilterType.LiveEvent, name: 'Live Events', label: 'Live Events' },
  { id: AssetFilterType.ExternalClip, name: 'External Clips', label: 'External Clips' },
];

// all AssetFilterTypeOptions above plus a filter to return just Images
export const AssetFilterTypeOptionsExtended: AssetFilterTypeOptions[] = [
  {
    id: AssetFilterType.NestedChannel,
    name: 'Nested/Collections',
    label: 'Nested/Collections',
    icon: <img src={nestedChannelIcon} alt="nested" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.ClipGroup,
    name: 'Clip Groups',
    label: 'Clip Groups',
    icon: <img src={clipGroupIcon} alt="clip group" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.LiveProgramAssets,
    name: 'Live Program Assets',
    label: 'Live Program Assets',
    icon: <img src={liveProgramAssetIcon} alt="live program" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.VODFileAssets,
    name: 'Videos',
    label: 'Videos',
    icon: <img src={videoClipIcon} alt="videos" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.Transitions,
    name: 'Transitions',
    label: 'Transitions',
    icon: <img src={transitionIcon} alt="transition" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.Image,
    name: 'Images',
    label: 'Images',
    icon: <img src={imageIcon} alt="image" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.LiveEvent,
    name: 'Live Events',
    label: 'Live Events',
    icon: <img src={liveEventIcon} alt="live event" />,
    iconAlign: 'right',
  },
  {
    id: AssetFilterType.ExternalClip,
    name: 'External Clips',
    label: 'External Clips',
    icon: <img src={externalVideoIcon} alt="external clip" />,
    iconAlign: 'right',
  },
];

export const GetAssetFilterTypeOptions = (type: AssetFilterType | AssetFilterType[]) => {
  if (_.isArray(type)) {
    const types: AssetFilterType[] = type;
    return AllAssetFilterTypeOptions.filter((a) => types.findIndex((t) => t === a.id) > -1);
  }
  return AllAssetFilterTypeOptions.filter((a) => a.id === type);
};
